import { createFileRoute } from '@tanstack/react-router';

import { AnalyzingPanel } from '../../features/onboarding/analyzing-panel';
import { requireOnboardingStage } from '../../features/onboarding/require-onboarding-stage';

export const Route = createFileRoute('/onboarding/analyzing')({
  beforeLoad: ({ context, location }) =>
    requireOnboardingStage({
      queryClient: context.queryClient,
      location,
      path: '/onboarding/analyzing',
    }),
  component: AnalyzingPanel,
});
